module.exports = __webpack_public_path__ + "static/media/vollig.d68851e6.jpg";